module.exports = __webpack_public_path__ + "static/Brand-Positioning-v2-c9f4cb8f717ace585ee81bd90b66bb3b.jpg";